import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            热门专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精选暴走黑料与黑料社系列专题，一站式吃瓜
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.slice(0, 6).map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-300 cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 bg-primary-500/90 text-background-50 text-xs font-semibold rounded-md">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-2 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1.5"></i>
                  <span>{item.views}次观看</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {cardItems.length > 6 && (
          <div className="mt-8">
            <article
              key={cardItems[6].id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-300 cursor-pointer"
            >
              <div className="flex flex-col md:flex-row">
                <div className="md:w-2/5 relative aspect-video md:aspect-auto overflow-hidden">
                  <img
                    src={cardItems[6].image}
                    alt={cardItems[6].title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="inline-block px-2.5 py-1 bg-accent-500/90 text-background-50 text-xs font-semibold rounded-md">
                      {cardItems[6].tag}
                    </span>
                  </div>
                </div>
                <div className="flex-1 p-5 md:p-8 flex flex-col justify-center">
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2 leading-snug">
                    {cardItems[6].title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    {cardItems[6].desc}
                  </p>
                  <div className="flex items-center text-xs text-foreground-400">
                    <i className="ri-eye-line mr-1.5"></i>
                    <span>{cardItems[6].views}次观看</span>
                  </div>
                </div>
              </div>
            </article>
          </div>
        )}
      </div>
    </section>
  );
}